import React, { useState, useEffect, useRef } from 'react'
import { updateCandidate, updateTicket, fetchTickets, uploadPhoto, uploadRouteFile, fetchCandidateTasks, addTask, updateTask, sendSpecvisa, sendTourvisa, sendVisaIssued, sendVisaReceived, updateChert } from '../lib/api'

const ALL_COUNTRIES = [
  { name: 'Австралия', flag: '🇦🇺' }, { name: 'Австрия', flag: '🇦🇹' }, { name: 'Азербайджан', flag: '🇦🇿' },
  { name: 'Албания', flag: '🇦🇱' }, { name: 'Алжир', flag: '🇩🇿' }, { name: 'Ангола', flag: '🇦🇴' },
  { name: 'Аргентина', flag: '🇦🇷' }, { name: 'Армения', flag: '🇦🇲' }, { name: 'Афганистан', flag: '🇦🇫' },
  { name: 'Бангладеш', flag: '🇧🇩' }, { name: 'Беларусь', flag: '🇧🇾' }, { name: 'Бельгия', flag: '🇧🇪' },
  { name: 'Бенин', flag: '🇧🇯' }, { name: 'Болгария', flag: '🇧🇬' }, { name: 'Боливия', flag: '🇧🇴' },
  { name: 'Ботсвана', flag: '🇧🇼' }, { name: 'Бразилия', flag: '🇧🇷' }, { name: 'Буркина-Фасо', flag: '🇧🇫' },
  { name: 'Бурунди', flag: '🇧🇮' }, { name: 'Великобритания', flag: '🇬🇧' }, { name: 'Венгрия', flag: '🇭🇺' },
  { name: 'Венесуэла', flag: '🇻🇪' }, { name: 'Вьетнам', flag: '🇻🇳' }, { name: 'Гамбия', flag: '🇬🇲' },
  { name: 'Гана', flag: '🇬🇭' }, { name: 'Гватемала', flag: '🇬🇹' }, { name: 'Гвинея', flag: '🇬🇳' },
  { name: 'Гвинея-Бисау', flag: '🇬🇼' }, { name: 'Германия', flag: '🇩🇪' }, { name: 'Греция', flag: '🇬🇷' },
  { name: 'Грузия', flag: '🇬🇪' }, { name: 'Дания', flag: '🇩🇰' }, { name: 'ДР Конго', flag: '🇨🇩' },
  { name: 'Египет', flag: '🇪🇬' }, { name: 'Замбия', flag: '🇿🇲' }, { name: 'Зимбабве', flag: '🇿🇼' },
  { name: 'Израиль', flag: '🇮🇱' }, { name: 'Индия', flag: '🇮🇳' }, { name: 'Индонезия', flag: '🇮🇩' },
  { name: 'Иордания', flag: '🇯🇴' }, { name: 'Ирак', flag: '🇮🇶' }, { name: 'Иран', flag: '🇮🇷' },
  { name: 'Ирландия', flag: '🇮🇪' }, { name: 'Испания', flag: '🇪🇸' }, { name: 'Италия', flag: '🇮🇹' },
  { name: 'Йемен', flag: '🇾🇪' }, { name: 'Казахстан', flag: '🇰🇿' }, { name: 'Камбоджа', flag: '🇰🇭' },
  { name: 'Камерун', flag: '🇨🇲' }, { name: 'Канада', flag: '🇨🇦' }, { name: 'Кения', flag: '🇰🇪' },
  { name: 'Кипр', flag: '🇨🇾' }, { name: 'Китай', flag: '🇨🇳' }, { name: 'Колумбия', flag: '🇨🇴' },
  { name: 'Конго', flag: '🇨🇬' }, { name: 'Кот-д\'Ивуар', flag: '🇨🇮' }, { name: 'Куба', flag: '🇨🇺' },
  { name: 'Кувейт', flag: '🇰🇼' }, { name: 'Кыргызстан', flag: '🇰🇬' }, { name: 'Лаос', flag: '🇱🇦' },
  { name: 'Либерия', flag: '🇱🇷' }, { name: 'Ливан', flag: '🇱🇧' }, { name: 'Ливия', flag: '🇱🇾' },
  { name: 'Мавритания', flag: '🇲🇷' }, { name: 'Мадагаскар', flag: '🇲🇬' }, { name: 'Малави', flag: '🇲🇼' },
  { name: 'Малайзия', flag: '🇲🇾' }, { name: 'Мали', flag: '🇲🇱' }, { name: 'Марокко', flag: '🇲🇦' },
  { name: 'Мексика', flag: '🇲🇽' }, { name: 'Мозамбик', flag: '🇲🇿' }, { name: 'Молдова', flag: '🇲🇩' },
  { name: 'Монголия', flag: '🇲🇳' }, { name: 'Мьянма', flag: '🇲🇲' }, { name: 'Намибия', flag: '🇳🇦' },
  { name: 'Нигер', flag: '🇳🇪' }, { name: 'Нигерия', flag: '🇳🇬' }, { name: 'Нидерланды', flag: '🇳🇱' },
  { name: 'Никарагуа', flag: '🇳🇮' }, { name: 'Норвегия', flag: '🇳🇴' }, { name: 'ОАЭ', flag: '🇦🇪' },
  { name: 'Пакистан', flag: '🇵🇰' }, { name: 'Панама', flag: '🇵🇦' }, { name: 'Перу', flag: '🇵🇪' },
  { name: 'Польша', flag: '🇵🇱' }, { name: 'Португалия', flag: '🇵🇹' }, { name: 'Республика Корея', flag: '🇰🇷' },
  { name: 'Россия', flag: '🇷🇺' }, { name: 'Руанда', flag: '🇷🇼' }, { name: 'Румыния', flag: '🇷🇴' },
  { name: 'Сальвадор', flag: '🇸🇻' }, { name: 'Саудовская Аравия', flag: '🇸🇦' }, { name: 'Сенегал', flag: '🇸🇳' },
  { name: 'Сербия', flag: '🇷🇸' }, { name: 'Сингапур', flag: '🇸🇬' }, { name: 'Сирия', flag: '🇸🇾' },
  { name: 'Сомали', flag: '🇸🇴' }, { name: 'Судан', flag: '🇸🇩' }, { name: 'Сьерра-Леоне', flag: '🇸🇱' },
  { name: 'Таджикистан', flag: '🇹🇯' }, { name: 'Таиланд', flag: '🇹🇭' }, { name: 'Танзания', flag: '🇹🇿' },
  { name: 'Того', flag: '🇹🇬' }, { name: 'Тунис', flag: '🇹🇳' }, { name: 'Туркменистан', flag: '🇹🇲' },
  { name: 'Турция', flag: '🇹🇷' }, { name: 'Уганда', flag: '🇺🇬' }, { name: 'Узбекистан', flag: '🇺🇿' },
  { name: 'Украина', flag: '🇺🇦' }, { name: 'Уругвай', flag: '🇺🇾' }, { name: 'Филиппины', flag: '🇵🇭' },
  { name: 'Финляндия', flag: '🇫🇮' }, { name: 'Франция', flag: '🇫🇷' }, { name: 'Чад', flag: '🇹🇩' },
  { name: 'Чехия', flag: '🇨🇿' }, { name: 'Чили', flag: '🇨🇱' }, { name: 'Швейцария', flag: '🇨🇭' },
  { name: 'Швеция', flag: '🇸🇪' }, { name: 'Шри-Ланка', flag: '🇱🇰' }, { name: 'Эквадор', flag: '🇪🇨' },
  { name: 'Эритрея', flag: '🇪🇷' }, { name: 'Эсватини', flag: '🇸🇿' }, { name: 'Эфиопия', flag: '🇪🇹' },
  { name: 'ЮАР', flag: '🇿🇦' }, { name: 'Южный Судан', flag: '🇸🇸' }, { name: 'Япония', flag: '🇯🇵' },
]
import MoscowPipeline from './MoscowPipeline'
import MoscowDocuments from './MoscowDocuments'
import { CitizenshipInput } from './CandidateModal'

const TIMEZONES = [
  { label: 'Гватемала (UTC-6)', value: 'America/Guatemala' },
  { label: 'Богота / Лима (UTC-5)', value: 'America/Bogota' },
  { label: 'Каракас (UTC-4)', value: 'America/Caracas' },
  { label: 'Буэнос-Айрес (UTC-3)', value: 'America/Argentina/Buenos_Aires' },
  { label: 'Бразилиа (UTC-3)', value: 'America/Sao_Paulo' },
  { label: 'Кабо-Верде (UTC-1)', value: 'Atlantic/Cape_Verde' },
  { label: 'Лондон (UTC+0/+1)', value: 'Europe/London' },
  { label: 'Лагос / Луанда (UTC+1)', value: 'Africa/Lagos' },
  { label: 'Берлин / Париж (UTC+1/+2)', value: 'Europe/Berlin' },
  { label: 'Каир (UTC+2)', value: 'Africa/Cairo' },
  { label: 'Харare / Йоханнесбург (UTC+2)', value: 'Africa/Harare' },
  { label: 'Найроби / Аддис-Абеба (UTC+3)', value: 'Africa/Nairobi' },
  { label: 'Москва (UTC+3)', value: 'Europe/Moscow' },
  { label: 'Стамбул (UTC+3)', value: 'Europe/Istanbul' },
  { label: 'Дубай / Маскат (UTC+4)', value: 'Asia/Dubai' },
  { label: 'Карачи (UTC+5)', value: 'Asia/Karachi' },
  { label: 'Дели (UTC+5:30)', value: 'Asia/Kolkata' },
  { label: 'Дакка (UTC+6)', value: 'Asia/Dhaka' },
  { label: 'Янгон (UTC+6:30)', value: 'Asia/Rangoon' },
  { label: 'Бангкок / Джакарта (UTC+7)', value: 'Asia/Bangkok' },
  { label: 'Манила / Пекин (UTC+8)', value: 'Asia/Manila' },
  { label: 'Токио / Сеул (UTC+9)', value: 'Asia/Tokyo' },
  { label: 'Порт-Морсби (UTC+10)', value: 'Pacific/Port_Moresby' },
  { label: 'Сидней (UTC+10/+11)', value: 'Australia/Sydney' },
  { label: 'Нумеа (UTC+11)', value: 'Pacific/Noumea' },
]

export function LocationModal({ mode, initialData, onSave, onDelete, onClose }) {
  const [form, setForm] = useState({
    name: '',
    icon: '📍',
    region: initialData?.region || 'АФРИКА',
    ...initialData,
  })
  const [saving, setSaving] = useState(false)
  const [countrySearch, setCountrySearch] = useState('')
  const [manualMode, setManualMode] = useState(false)

  function set(field, value) { setForm(f => ({ ...f, [field]: value })) }

  function selectCountry(country) {
    setForm(f => ({ ...f, name: country.name, icon: country.flag }))
  }

  async function handleSubmit(e) {
    e.preventDefault()
    if (!form.name.trim()) return
    setSaving(true)
    await onSave({ ...form })
    setSaving(false)
  }

  const filteredCountries = countrySearch.trim()
    ? ALL_COUNTRIES.filter(c => c.name.toLowerCase().includes(countrySearch.toLowerCase()))
    : ALL_COUNTRIES

  const REGIONS = ['АФРИКА', 'АЗИЯ', 'ЛАТАМ', 'МОСКВА']

  return (
    <div className="modal-backdrop">
      <div className="modal modal-sm" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{mode === 'add' ? 'Новая локация' : 'Редактировать локацию'}</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit} className="modal-form">
          {mode === 'add' && !manualMode ? (
            <>
              <div style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 6 }}>Выберите страну</div>
                <input
                  autoFocus
                  placeholder="🔍 Поиск страны..."
                  value={countrySearch}
                  onChange={e => setCountrySearch(e.target.value)}
                  style={{ width: '100%', fontSize: 13, padding: '8px 10px', borderRadius: 8, border: '1px solid #e0e0dc', boxSizing: 'border-box', outline: 'none' }}
                />
              </div>
              <div style={{ maxHeight: 260, overflowY: 'auto', border: '1px solid #e8e8e5', borderRadius: 10, marginBottom: 10 }}>
                {filteredCountries.length === 0 && (
                  <div style={{ fontSize: 12, color: '#aaa', padding: '16px', textAlign: 'center' }}>Ничего не найдено</div>
                )}
                {filteredCountries.map(c => (
                  <div key={c.name} onClick={() => selectCountry(c)}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', cursor: 'pointer',
                      background: form.name === c.name ? '#f0f7ff' : 'white',
                      borderLeft: form.name === c.name ? '3px solid #378ADD' : '3px solid transparent',
                      transition: 'background 0.1s',
                    }}
                    onMouseOver={e => { if (form.name !== c.name) e.currentTarget.style.background = '#fafaf8' }}
                    onMouseOut={e => { if (form.name !== c.name) e.currentTarget.style.background = 'white' }}>
                    <span style={{ fontSize: 18 }}>{c.flag}</span>
                    <span style={{ fontSize: 13 }}>{c.name}</span>
                  </div>
                ))}
              </div>
              {form.name && (
                <div style={{ fontSize: 13, color: '#1a1a1a', marginBottom: 10, padding: '7px 12px', background: '#f0f7ff', borderRadius: 8, border: '1px solid #b8d4f0' }}>
                  Выбрано: <strong>{form.icon} {form.name}</strong>
                </div>
              )}
              <button type="button" onClick={() => setManualMode(true)}
                style={{ fontSize: 12, color: '#888', background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginBottom: 10, textDecoration: 'underline' }}>
                Добавить вручную
              </button>
            </>
          ) : mode === 'add' && manualMode ? (
            <>
              <button type="button" onClick={() => setManualMode(false)}
                style={{ fontSize: 12, color: '#378ADD', background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginBottom: 10 }}>
                ← Назад к списку стран
              </button>
              <label>Название *
                <input autoFocus required value={form.name} onChange={e => set('name', e.target.value)} placeholder="Название локации" />
              </label>
              <label>Иконка (эмодзи)
                <input value={form.icon} onChange={e => set('icon', e.target.value)} maxLength={2} style={{ width: 70 }} />
              </label>
            </>
          ) : (
            <>
              <label>Название
                <input value={form.name} onChange={e => set('name', e.target.value)} />
              </label>
              <label>Иконка
                <input value={form.icon} onChange={e => set('icon', e.target.value)} maxLength={2} style={{ width: 70 }} />
              </label>
            </>
          )}
          <label>Регион
            <select value={form.region} onChange={e => set('region', e.target.value)}>
              {REGIONS.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
          </label>
          <div className="modal-actions">
            {mode === 'edit' && (
              <button type="button" className="btn btn-danger" onClick={() => onDelete(initialData.id)}>Удалить</button>
            )}
            <button type="button" className="btn btn-outline" onClick={onClose}>Отмена</button>
            <button type="submit" className="btn btn-primary" disabled={saving || !form.name.trim()}>
              {saving ? 'Сохранение...' : mode === 'add' ? 'Добавить' : 'Сохранить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

function ExpenseRow({ exp }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: 12, borderBottom: '0.5px solid #f0f0ec' }}>
      <div>
        <div style={{ color: '#444' }}>{exp.category || '—'}{exp.source === 'statement' && <span title="Доля расходов по карте …6921 из выписки банка — правится только через журнал выписок" style={{ marginLeft: 6, fontSize: 10, padding: '1px 6px', borderRadius: 6, background: '#E8F1FB', color: '#1A3A5C', fontWeight: 600 }}>по выписке</span>}</div>
        {exp.comment && <div style={{ fontSize: 11, color: '#999' }}>{exp.comment.includes(':') ? exp.comment.slice(exp.comment.indexOf(':') + 1).trim() : exp.comment}</div>}
      </div>
      <span style={{ fontWeight: 500, color: '#1a1a1a', flexShrink: 0, marginLeft: 8 }}>{parseFloat(exp.amount || 0).toLocaleString('ru-RU')} ₽</span>
    </div>
  )
}

function ExpensesBlock({ expenses, total }) {
  const [open, setOpen] = useState(false)

  const regular = [...expenses].filter(e => e.category !== 'Оформление в Москве').sort((a, b) => (a.date || '').localeCompare(b.date || ''))
  const moscow = [...expenses].filter(e => e.category === 'Оформление в Москве').sort((a, b) => (a.date || '').localeCompare(b.date || ''))
  const moscowTotal = moscow.reduce((s, e) => s + (parseFloat(e.amount) || 0), 0)

  return (
    <div className="route-block" style={{ marginBottom: 10 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={() => setOpen(o => !o)}>
        <div className="route-label" style={{ margin: 0 }}>Расходы</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: '#639922' }}>{total.toLocaleString('ru-RU')} ₽</span>
          <span style={{ fontSize: 12, color: '#aaa' }}>{open ? '▲' : '▼'}</span>
        </div>
      </div>
      {open && (
        <div style={{ marginTop: 8 }}>
          {regular.map((exp, i) => <ExpenseRow key={i} exp={exp} />)}

          {moscow.length > 0 && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '10px 0 6px', opacity: 0.5 }}>
                <div style={{ flex: 1, height: 1, background: '#d0d0cc' }} />
                <span style={{ fontSize: 10, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap' }}>🏛 Оформление в Москве</span>
                <div style={{ flex: 1, height: 1, background: '#d0d0cc' }} />
              </div>
              {moscow.map((exp, i) => <ExpenseRow key={'m' + i} exp={exp} />)}
              {regular.length > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: 11, color: '#888', marginTop: 2 }}>
                  <span>Итого МСК</span>
                  <span>{moscowTotal.toLocaleString('ru-RU')} ₽</span>
                </div>
              )}
            </>
          )}

          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: 13, fontWeight: 600, marginTop: 4, borderTop: '1px solid #f0f0ec' }}>
            <span>Итого</span>
            <span style={{ color: '#639922' }}>{total.toLocaleString('ru-RU')} ₽</span>
          </div>
        </div>
      )}
    </div>
  )
}

const STATUSES = ['ожидает', 'в пути', 'прибыл', 'завершен']
const FLAGS = ['', '🔴', '🟡', '🟢', '⭐', '❗']

export function DetailModal({ candidate: c, location, statusColors, onEdit, onDelete, onClose, canEdit, canDelete, onArchive, onMoveToSpecial, onMoveToMain, currentUserId, isAdmin, isOperator, isMoscowOperator, currentUser, onBack, initialTab, locations, onUpdateCandidate, agents = [], canSeeAgents = true }) {
  const color = statusColors[c.status] || '#aaa'
  const route = (Array.isArray(c.route) ? c.route : []).filter(p => p.from && p.to)
  const tz = location?.timezone || 'Europe/Moscow'
  const isMoscow = location?.name?.toLowerCase().includes('москва') || tz === 'Europe/Moscow'
  const isDwan = currentUserId === '2ea62d7a-3c1d-4c96-9435-e635538852fe'
  const [tickets, setTickets] = useState([])
  const [ticketsLoading, setTicketsLoading] = useState(true)
  const [activeTab, setActiveTab] = useState(isMoscowOperator ? 'moscow' : (initialTab || 'details'))
  const [saving, setSaving] = useState(false)
  const [deleteConfirm, setDeleteConfirm] = useState(false)
  const [showVisaPanel, setShowVisaPanel] = useState(false)
  const [visaType, setVisaType] = useState(null)
  const [visaEmbassy, setVisaEmbassy] = useState('')
  const [visaSending, setVisaSending] = useState(false)
  const [specvisaLastSent, setSpecvisaLastSent] = useState(c.specvisa_sent_at ? { at: c.specvisa_sent_at, by: c.specvisa_sent_by } : null)
  const [tourvisaLastSent, setTourvisaLastSent] = useState(c.tourvisa_sent_at ? { at: c.tourvisa_sent_at, embassy: c.tourvisa_embassy } : null)
  const [visaIssuedSending, setVisaIssuedSending] = useState(false)
  const [visaIssuedConfirm, setVisaIssuedConfirm] = useState(false)
  const [visaReceivedSending, setVisaReceivedSending] = useState(false)
  const [showVisaReceived, setShowVisaReceived] = useState(false)
  const [visaIssuedAt, setVisaIssuedAt] = useState(c.visa_issued_at || null)
  const [visaReceivedAt, setVisaReceivedAt] = useState(c.visa_received_at || null)
  const [peterVisaAt, setPeterVisaAt] = useState(c.peter_visa_submitted_at || null)
  const [fastMark, setFastMark] = useState(c.fast_resubmit_at ? { at: c.fast_resubmit_at, by: c.fast_resubmit_by } : null)
  const [visaPhotoFile, setVisaPhotoFile] = useState(null)
  const [visaPhotoPreview, setVisaPhotoPreview] = useState(null)
  const [photoUploading, setPhotoUploading] = useState(false)
  const [passportUploading, setPassportUploading] = useState(false)
  const [showPassportPaste, setShowPassportPaste] = useState(false)
  const [showMedPaste, setShowMedPaste] = useState(false)
  const [showVisaPaste, setShowVisaPaste] = useState(false)
  const [medDocs, setMedDocs] = useState(c.med_docs || [])
  const [medUploading, setMedUploading] = useState(false)
  const [medLabel, setMedLabel] = useState('')
  const [resubmitStep, setResubmitStep] = useState(0) // 0=hidden, 1=embassy input, 2=sending
  const [resubmitEmbassy, setResubmitEmbassy] = useState('')
  const [resubmitSending, setResubmitSending] = useState(false)
  const [chertStep, setChertStep] = useState(0) // 0=hidden, 1=confirm, 2=reason
  const [chertReason, setChertReason] = useState('')
  const [chertSaving, setChertSaving] = useState(false)
  const [isChert, setIsChert] = useState(c.is_chert || false)
  const [medPendingFile, setMedPendingFile] = useState(null)
  const medInputRef = React.useRef(null)
  const [editingQuestionnaire, setEditingQuestionnaire] = useState(false)
  const [questionnaireOpen, setQuestionnaireOpen] = useState(false)
  const [questionnaireText, setQuestionnaireText] = useState(c.questionnaire_text || '')
  const [savingQuestionnaire, setSavingQuestionnaire] = useState(false)
  const [editingName, setEditingName] = useState(false)
  const [nameValue, setNameValue] = useState(c.name || '')
  const [editingPassport, setEditingPassport] = useState(false)
  const [passportValue, setPassportValue] = useState(c.passport || '')
  const [editingPhone, setEditingPhone] = useState(false)
  const [phoneValue, setPhoneValue] = useState(c.phone || '')
  const [candidateTasks, setCandidateTasks] = useState([])
  const [taskInput, setTaskInput] = useState('')
  const [taskSaving, setTaskSaving] = useState(false)

  useEffect(() => {
    fetchCandidateTasks(c.id).then(setCandidateTasks).catch(() => {})
  }, [c.id])
  const photoInputRef = useRef(null)
  const passportInputRef = useRef(null)
  const passportPasteRef = useRef(null)
  const medPasteRef = useRef(null)
  const visaPasteRef = useRef(null)

  useEffect(() => { if (showPassportPaste && passportPasteRef.current) passportPasteRef.current.focus() }, [showPassportPaste])
  useEffect(() => { if (showMedPaste && medPasteRef.current) medPasteRef.current.focus() }, [showMedPaste])
  useEffect(() => { if (showVisaPaste && visaPasteRef.current) visaPasteRef.current.focus() }, [showVisaPaste])

  async function handlePhotoUpload(e) {
    const file = e.target.files[0]
    if (!file) return
    setPhotoUploading(true)
    try {
      const url = await uploadPhoto(file, c.id)
      await onUpdateCandidate(c.id, { photo_url: url })
    } catch (err) { alert('Ошибка загрузки фото: ' + err.message) }
    setPhotoUploading(false)
    e.target.value = ''
  }

  async function handlePassportPhotoUpload(e) {
    const files = Array.from(e.target.files)
    if (!files.length) return
    setPassportUploading(true)
    try {
      const uploaded = await Promise.all(files.map(f => uploadRouteFile(f, c.id, 'passport')))
      const updated = [...(c.passport_photos || []), ...uploaded]
      await onUpdateCandidate(c.id, { passport_photos: updated })
    } catch (err) { alert('Ошибка загрузки: ' + err.message) }
    setPassportUploading(false)
    e.target.value = ''
  }

  async function handlePassportPhotoDelete(idx) {
    const updated = (c.passport_photos || []).filter((_, i) => i !== idx)
    await onUpdateCandidate(c.id, { passport_photos: updated })
  }

  async function handlePassportPhotoReplace(e) {
    const file = e.target.files[0]
    if (!file) return
    setPassportUploading(true)
    try {
      const uploaded = await uploadRouteFile(file, c.id, 'passport')
      const updated = [uploaded]
      await onUpdateCandidate(c.id, { passport_photos: updated })
    } catch (err) { alert('Ошибка загрузки: ' + err.message) }
    setPassportUploading(false)
    e.target.value = ''
  }

  async function handleMedFileSelect(e) {
    const file = e.target.files[0]
    if (!file) return
    setMedPendingFile(file)
    e.target.value = ''
  }

  async function handleMedUploadConfirm() {
    if (!medPendingFile) return
    setMedUploading(true)
    try {
      const uploaded = await uploadRouteFile(medPendingFile, c.id, 'med')
      const label = medLabel.trim() || medPendingFile.name
      const newDoc = { url: uploaded.url, name: uploaded.name, label }
      const updated = [...medDocs, newDoc]
      await onUpdateCandidate(c.id, { med_docs: updated })
      setMedDocs(updated)
      setMedPendingFile(null)
      setMedLabel('')
    } catch (err) { alert('Ошибка загрузки: ' + err.message) }
    setMedUploading(false)
  }

  async function handlePassportPaste(e) {
    const items = Array.from(e.clipboardData?.items || [])
    const imgItem = items.find(it => it.type.startsWith('image/'))
    if (!imgItem) return
    e.preventDefault()
    const file = imgItem.getAsFile()
    if (!file) return
    setShowPassportPaste(false)
    setPassportUploading(true)
    try {
      const uploaded = await uploadRouteFile(file, c.id, 'passport')
      await onUpdateCandidate(c.id, { passport_photos: [uploaded] })
    } catch (err) { alert('Ошибка загрузки: ' + err.message) }
    setPassportUploading(false)
  }

  async function handleMedPaste(e) {
    const items = Array.from(e.clipboardData?.items || [])
    const imgItem = items.find(it => it.type.startsWith('image/'))
    if (!imgItem) return
    e.preventDefault()
    const file = imgItem.getAsFile()
    if (!file) return
    setShowMedPaste(false)
    setMedPendingFile(file)
  }

  function handleVisaPaste(e) {
    const items = Array.from(e.clipboardData?.items || [])
    const imgItem = items.find(it => it.type.startsWith('image/'))
    if (!imgItem) return
    e.preventDefault()
    const file = imgItem.getAsFile()
    if (!file) return
    setShowVisaPaste(false)
    setVisaPhotoFile(file)
    setVisaPhotoPreview(URL.createObjectURL(file))
  }

  async function handleMedDelete(idx) {
    const updated = medDocs.filter((_, i) => i !== idx)
    await onUpdateCandidate(c.id, { med_docs: updated })
    setMedDocs(updated)
  }

  async function handleSaveQuestionnaire() {
    setSavingQuestionnaire(true)
    try {
      await onUpdateCandidate(c.id, { questionnaire_text: questionnaireText })
      setEditingQuestionnaire(false)
    } catch (err) { alert('Ошибка: ' + err.message) }
    setSavingQuestionnaire(false)
  }

  async function handleFieldUpdate(field, value) {
    if (!onUpdateCandidate) return
    setSaving(true)
    try { await onUpdateCandidate(c.id, { [field]: value }) } catch (e) { alert('Ошибка: ' + e.message) }
    setSaving(false)
  }

  const isViewer = currentUser?.role === 'viewer'
  const showMoscowTab = isMoscow && (isAdmin || isMoscowOperator || isViewer)

React.useEffect(() => {
    fetchTickets().then(all => {
      setTickets(all.filter(t => t.candidate_id === c.id))
      setTicketsLoading(false)
    }).catch(() => setTicketsLoading(false))
  }, [c.id])

async function handleStatusChange(ticketId, newStatus) {
try {      const updates = { refund_status: newStatus }
      if (newStatus === 'Возврат') updates.refund_date = new Date().toISOString().split('T')[0]
      await updateTicket(ticketId, updates)
      setTickets(prev => prev.map(t => t.id === ticketId ? { ...t, ...updates } : t))
    } catch (e) { alert('Ошибка: ' + e.message) }
  }

  function formatDT(date, time, timezone) {
    if (!date) return null
    try {
      const timeStr = time ? time.slice(0, 5) : '00:00'
      const [year, month, day] = date.split('-').map(Number)
      const [hours, minutes] = timeStr.split(':').map(Number)
      const dt = new Date(Date.UTC(year, month - 1, day, hours, minutes))
      const d = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric' }).format(dt)
      const t = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' }).format(dt)
      return time ? d + ' ' + t : d
    } catch (e) { return date }
  }

  function TimeBlock({ date, time, tz: tzProp }) {
    if (!date) return <div style={{ fontSize: 12, color: '#bbb' }}>—</div>
    const localTz = tzProp || 'Europe/Moscow'
    const isLocalMoscow = localTz === 'Europe/Moscow'
    const local = formatDT(date, time, localTz)
    const msk = isLocalMoscow ? null : (() => {
      try {
        const timeStr = time ? time.slice(0, 5) : '00:00'
        const [year, month, day] = date.split('-').map(Number)
        const [h, m] = timeStr.split(':').map(Number)
        const localDt = new Date(Date.UTC(year, month - 1, day, h, m))
        const getOffsetMin = (tz) => {
          const parts = new Intl.DateTimeFormat('en', { timeZone: tz, timeZoneName: 'longOffset' }).formatToParts(localDt)
          const s = parts.find(p => p.type === 'timeZoneName')?.value || 'GMT+00:00'
          const match = s.match(/GMT([+-])(\d+):(\d+)/)
          if (!match) return 0
          return (match[1] === '+' ? 1 : -1) * (parseInt(match[2]) * 60 + parseInt(match[3]))
        }
        const diffMin = getOffsetMin('Europe/Moscow') - getOffsetMin(localTz)
        const mskDt = new Date(localDt.getTime() + diffMin * 60000)
        const d = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric' }).format(mskDt)
        const t = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' }).format(mskDt)
        return time ? d + ' ' + t : d
      } catch(e) { return null }
    })()
    return (
      <div style={{ display: 'grid', gridTemplateColumns: isLocalMoscow ? '1fr' : 'minmax(0,1fr) minmax(0,1fr)', gap: 8, background: '#f9f9f7', borderRadius: 8, padding: '6px 10px', marginTop: 4, overflow: 'hidden' }}>
        <div>
          <div style={{ fontSize: 10, color: '#aaa', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 2 }}>Местное</div>
          <div style={{ fontSize: 13, fontWeight: 500, color: '#1a1a1a' }}>{local}</div>
        </div>
        {!isLocalMoscow && msk && (
          <div style={{ borderLeft: '1px solid #efefec', paddingLeft: 8 }}>
            <div style={{ fontSize: 10, color: '#aaa', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 2 }}>МСК</div>
            <div style={{ fontSize: 13, fontWeight: 500, color: '#378ADD', wordBreak: 'break-word' }}>{msk}</div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="modal-backdrop">
      <div className="modal modal-sm" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          {onBack && <button onClick={onBack} style={{ background: 'transparent', border: 'none', cursor: 'pointer', fontSize: 18, color: '#888', marginRight: 8, padding: '2px 4px' }}>←</button>}
          <h2>Карточка кандидата</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="detail-body">
          {showMoscowTab && (
            <div style={{ display: 'flex', gap: 0, marginBottom: 16, borderBottom: '1px solid #f0f0ec' }}>
              {[
                { key: 'details', label: 'Детали' },
                { key: 'moscow', label: '🏛 Оформление' },
                { key: 'docs', label: '📁 Документы' },
              ].map(tab => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  style={{
                    fontSize: 12, padding: '7px 12px', border: 'none', cursor: 'pointer',
                    background: 'transparent', fontWeight: activeTab === tab.key ? 600 : 400,
                    color: activeTab === tab.key ? '#1a1a1a' : '#888',
                    borderBottom: activeTab === tab.key ? '2px solid #1a1a1a' : '2px solid transparent',
                    marginBottom: -1, whiteSpace: 'nowrap',
                  }}
                >{tab.label}</button>
              ))}
            </div>
          )}

          {activeTab === 'moscow' && showMoscowTab ? (
            <MoscowPipeline
              candidate={c}
              currentUser={currentUser || { id: currentUserId, full_name: '', role: isMoscowOperator ? 'moscow_operator' : isViewer ? 'viewer' : (isAdmin ? 'admin' : 'operator') }}
              onExpenseAdded={() => {}}
              onComplete={() => {
                if (onUpdateCandidate) onUpdateCandidate(c.id, { moscow_completed: true, moscow_completed_at: new Date().toISOString() })
                onClose()
              }}
            />
          ) : activeTab === 'docs' && showMoscowTab ? (
            <MoscowDocuments candidate={c} />
          ) : (
          <>
          <div className="detail-top">
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0, gap: 4 }}>
              <div style={{ cursor: canEdit && onUpdateCandidate ? 'pointer' : 'default', position: 'relative' }}
                onClick={() => canEdit && onUpdateCandidate && !photoUploading && photoInputRef.current?.click()}>
                <div className="detail-avatar">
                  {c.photo_url ? <img src={c.photo_url} alt={c.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ fontSize: 24, color: '#999' }}>👤</span>}
                  {canEdit && onUpdateCandidate && (
                    <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: photoUploading ? 1 : 0, transition: 'opacity 0.15s' }}
                      onMouseOver={e => !photoUploading && (e.currentTarget.style.opacity = 1)}
                      onMouseOut={e => !photoUploading && (e.currentTarget.style.opacity = 0)}>
                      <span style={{ fontSize: 18, color: 'white' }}>{photoUploading ? '...' : '📷'}</span>
                    </div>
                  )}
                </div>
              </div>
              {canEdit && onUpdateCandidate && <input ref={photoInputRef} type="file" accept="image/*" onChange={handlePhotoUpload} style={{ display: 'none' }} disabled={photoUploading} />}
              {c.photo_url && (
                <a href={c.photo_url} target="_blank" rel="noreferrer"
                  style={{ fontSize: 11, color: '#185FA5', textDecoration: 'none' }}
                  title="Открыть фото">⬇ фото</a>
              )}
            </div>
            <div style={{ flex: 1 }}>
              {editingName ? (
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 4 }}>
                  <input value={nameValue} onChange={e => setNameValue(e.target.value.toUpperCase())} style={{ fontSize: 15, fontWeight: 600, padding: '4px 8px', borderRadius: 8, border: '1px solid #378ADD', flex: 1 }} autoFocus />
                  <button onClick={async () => { if (!nameValue.trim()) return; await handleFieldUpdate('name', nameValue.trim()); setEditingName(false) }} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: 'none', background: '#1a1a1a', color: 'white', cursor: 'pointer' }}>✓</button>
                  <button onClick={() => { setNameValue(c.name); setEditingName(false) }} style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>✕</button>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div className="detail-name">{c.name}</div>
                  {canEdit && <button onClick={() => { setNameValue(c.name); setEditingName(true) }} style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#666', flexShrink: 0 }}>✏ имя</button>}
                </div>
              )}
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6 }}>
                <select value={c.status || ''} disabled={saving || !canEdit} onChange={e => handleFieldUpdate('status', e.target.value)}
                  style={{ fontSize: 12, padding: '4px 8px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>
                  {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
                <select value={c.location_id || ''} disabled={saving || !canEdit} onChange={e => handleFieldUpdate('location_id', e.target.value)}
                  style={{ fontSize: 12, padding: '4px 8px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', maxWidth: 140 }}>
                  {(locations || []).map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
                </select>
                <select value={c.flag || ''} disabled={saving || !canEdit} onChange={e => handleFieldUpdate('flag', e.target.value)}
                  style={{ fontSize: 12, padding: '4px 8px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>
                  {FLAGS.map(f => <option key={f} value={f}>{f || '— флаг —'}</option>)}
                </select>
              </div>
            </div>
          </div>

          {c.departure_info && (
            <div style={{ background: '#E6F1FB', border: '1px solid #378ADD44', borderRadius: 10, padding: '10px 14px', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ fontSize: 20 }}>✈️</span>
              <div>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#0C447C' }}>ВЫЛЕТ ПОДТВЕРЖДЁН</div>
                {c.departure_info.flight && <div style={{ fontSize: 12, color: '#185FA5' }}>Рейс: {c.departure_info.flight}</div>}
                <div style={{ fontSize: 11, color: '#378ADD' }}>
                  {c.departure_info.confirmed_by && `Подтвердил: ${c.departure_info.confirmed_by} · `}
                  {c.departure_info.confirmed_at && new Date(c.departure_info.confirmed_at).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                </div>
              </div>
            </div>
          )}
          <table className="detail-table">
            <tbody>
              {c.entry_date && <tr><td>Дата добавления</td><td>{String(c.entry_date).slice(0,10).split('-').reverse().join('.')}</td></tr>}
              <tr><td>Гражданство</td><td>
                {canEdit && onUpdateCandidate ? (
                  <CitizenshipInput
                    value={c.citizenship || ''}
                    onChange={async val => {
                      if (!val || val === c.citizenship) return
                      setSaving(true)
                      try { await onUpdateCandidate(c.id, { citizenship: val }) }
                      catch (err) { alert('Ошибка: ' + err.message) }
                      setSaving(false)
                    }}
                  />
                ) : (c.citizenship || '—')}
              </td></tr>
              {c.city && <tr><td>Город</td><td>{c.city}</td></tr>}
              <tr><td>Паспорт</td><td>
                {canEdit && editingPassport ? (
                  <span style={{ display: 'flex', gap: 4 }}>
                    <input type="text" inputMode="text" autoComplete="off" autoFocus value={passportValue} onChange={e => setPassportValue(e.target.value)}
                      onKeyDown={async e => {
                        if (e.key === 'Enter') { setSaving(true); try { await onUpdateCandidate(c.id, { passport: passportValue }) } catch(err) { alert(err.message) } setSaving(false); setEditingPassport(false) }
                        if (e.key === 'Escape') setEditingPassport(false)
                      }}
                      style={{ fontSize: 13, padding: '2px 6px', borderRadius: 5, border: '1px solid #378ADD', outline: 'none', width: 140 }} />
                    <button onClick={async () => { setSaving(true); try { await onUpdateCandidate(c.id, { passport: passportValue }) } catch(err) { alert(err.message) } setSaving(false); setEditingPassport(false) }}
                      style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: 'none', background: '#378ADD', color: 'white', cursor: 'pointer' }}>✓</button>
                    <button onClick={() => setEditingPassport(false)}
                      style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>✕</button>
                  </span>
                ) : (
                  <span style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    {c.passport || '—'}
                    {canEdit && <button onClick={() => { setPassportValue(c.passport || ''); setEditingPassport(true) }} style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#666' }}>✏</button>}
                  </span>
                )}
              </td></tr>
              {!(isDwan && c.responsible_name !== 'Данил') && <tr><td>Телефон</td><td>
                {canEdit && editingPhone ? (
                  <span style={{ display: 'flex', gap: 4 }}>
                    <input autoFocus value={phoneValue} onChange={e => setPhoneValue(e.target.value)}
                      onKeyDown={async e => {
                        if (e.key === 'Enter') { setSaving(true); try { await onUpdateCandidate(c.id, { phone: phoneValue }) } catch(err) { alert(err.message) } setSaving(false); setEditingPhone(false) }
                        if (e.key === 'Escape') setEditingPhone(false)
                      }}
                      style={{ fontSize: 13, padding: '2px 6px', borderRadius: 5, border: '1px solid #378ADD', outline: 'none', width: 140 }} />
                    <button onClick={async () => { setSaving(true); try { await onUpdateCandidate(c.id, { phone: phoneValue }) } catch(err) { alert(err.message) } setSaving(false); setEditingPhone(false) }}
                      style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: 'none', background: '#378ADD', color: 'white', cursor: 'pointer' }}>✓</button>
                    <button onClick={() => setEditingPhone(false)}
                      style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>✕</button>
                  </span>
                ) : (
                  <span style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    {c.phone || '—'}
                    {canEdit && <button onClick={() => { setPhoneValue(c.phone || ''); setEditingPhone(true) }} style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#666' }}>✏</button>}
                  </span>
                )}
              </td></tr>}
              <tr><td>Ответственный</td><td>{c.responsible_name || '—'}</td></tr>
              {canSeeAgents && <tr><td>Агент</td><td>
                {onUpdateCandidate && agents.length > 0 ? (
                  <select value={c.agent_id || ''} disabled={saving}
                    onChange={async e => {
                      const agent = agents.find(a => a.id === e.target.value)
                      setSaving(true)
                      try { await onUpdateCandidate(c.id, { agent_id: e.target.value || null, agent_name: agent?.name || null }) }
                      catch (err) { alert('Ошибка: ' + err.message) }
                      setSaving(false)
                    }}
                    style={{ fontSize: 12, padding: '3px 6px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', maxWidth: 180 }}>
                    <option value="">— без агента —</option>
                    {agents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                  </select>
                ) : (c.agent_name || '—')}
              </td></tr>}
              {c.archived && c.archive_reason && <tr><td>Причина архива</td><td style={{ color: '#E24B4A' }}>{c.archive_reason}</td></tr>}
              {isAdmin && onUpdateCandidate && (
                <tr><td>Видимость</td><td>
                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontSize: 12, cursor: 'pointer', userSelect: 'none' }}>
                    <input type="checkbox" checked={!!c.is_restricted} onChange={async e => {
                      setSaving(true)
                      try { await onUpdateCandidate(c.id, { is_restricted: e.target.checked }) }
                      catch (err) { alert('Ошибка: ' + err.message) }
                      setSaving(false)
                    }} />
                    <span style={{ color: c.is_restricted ? '#E24B4A' : '#888' }}>
                      {c.is_restricted ? '🔒 Скрыт от ограниченных' : 'Виден всем'}
                    </span>
                  </label>
                </td></tr>
              )}
            </tbody>
          </table>

          <div className="route-block" style={{ marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: questionnaireOpen ? 8 : 0, cursor: 'pointer' }} onClick={() => setQuestionnaireOpen(o => !o)}>
              <div className="route-label" style={{ margin: 0 }}>Анкета {c.questionnaire_text ? <span style={{ fontWeight: 400, color: '#aaa', fontSize: 10 }}>{questionnaireOpen ? '▲ свернуть' : '▼ развернуть'}</span> : <span style={{ fontWeight: 400, color: '#bbb', fontSize: 10 }}>не заполнена</span>}</div>
              {onUpdateCandidate && !editingQuestionnaire && questionnaireOpen && (
                <button onClick={e => { e.stopPropagation(); setQuestionnaireText(c.questionnaire_text || ''); setEditingQuestionnaire(true) }}
                  style={{ fontSize: 11, padding: '2px 8px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#666' }}>✏ Изменить</button>
              )}
            </div>
            {questionnaireOpen && (editingQuestionnaire ? (
              <div>
                <textarea value={questionnaireText} onChange={e => setQuestionnaireText(e.target.value)}
                  rows={6} style={{ width: '100%', fontSize: 12, padding: '8px 10px', borderRadius: 8, border: '1px solid #e0e0dc', resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.6, boxSizing: 'border-box' }} />
                <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
                  <button onClick={handleSaveQuestionnaire} disabled={savingQuestionnaire}
                    style={{ fontSize: 12, padding: '5px 14px', borderRadius: 7, border: 'none', background: '#1a1a1a', color: 'white', cursor: 'pointer', fontWeight: 600 }}>
                    {savingQuestionnaire ? 'Сохранение...' : 'Сохранить'}
                  </button>
                  <button onClick={() => setEditingQuestionnaire(false)}
                    style={{ fontSize: 12, padding: '5px 12px', borderRadius: 7, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#888' }}>Отмена</button>
                </div>
              </div>
            ) : (
              <div style={{ fontSize: 12, color: '#444', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
                {c.questionnaire_text}
              </div>
            ))}
          </div>

          <div className="route-block" style={{ marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <div className="route-label" style={{ margin: 0 }}>Фото паспорта</div>
              {canEdit && onUpdateCandidate && !isDwan && (
                <>
                  <button onClick={() => !passportUploading && setShowPassportPaste(v => !v)}
                    style={{ fontSize: 11, padding: '2px 8px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#666' }}
                    disabled={passportUploading}>
                    {passportUploading ? 'Загрузка...' : (c.passport_photos?.length ? '🔄 Заменить' : '+ Прикрепить')}
                  </button>
                  <input ref={passportInputRef} type="file" accept="image/*" onChange={handlePassportPhotoReplace} style={{ display: 'none' }} disabled={passportUploading} />
                </>
              )}
            </div>
            {(!c.passport_photos || c.passport_photos.length === 0) && (
              <div style={{ fontSize: 12, color: '#bbb' }}>Фото не прикреплено</div>
            )}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {(c.passport_photos || []).map((f, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 4, background: '#fafaf8', border: '1px solid #efefec', borderRadius: 7, padding: '4px 8px' }}>
                  <a href={f.url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#185FA5', textDecoration: 'none' }}>📄 {f.name}</a>
                </div>
              ))}
            </div>
            {showPassportPaste && (
              <div ref={passportPasteRef} onPaste={handlePassportPaste} tabIndex={0}
                style={{ marginTop: 8, border: '2px dashed #b3c8e8', borderRadius: 8, padding: '14px 12px', textAlign: 'center', fontSize: 13, color: '#555', background: '#f5f9ff', cursor: 'default', outline: 'none' }}
                onClick={() => passportInputRef.current?.click()}>
                Вставьте фото (Ctrl+V) или нажмите для выбора файла
              </div>
            )}
          </div>

          <div className="route-block" style={{ marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <div className="route-label" style={{ margin: 0 }}>Медицинские документы</div>
              {canEdit && onUpdateCandidate && (
                <>
                  <button onClick={() => setShowMedPaste(v => !v)}
                    style={{ fontSize: 11, padding: '2px 8px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#666' }}>
                    + Добавить
                  </button>
                  <input ref={medInputRef} type="file" accept="image/*,.pdf" onChange={handleMedFileSelect} style={{ display: 'none' }} />
                </>
              )}
            </div>
            {showMedPaste && (
              <div ref={medPasteRef} onPaste={handleMedPaste} tabIndex={0}
                style={{ marginTop: 4, marginBottom: 8, border: '2px dashed #b3c8e8', borderRadius: 8, padding: '14px 12px', textAlign: 'center', fontSize: 13, color: '#555', background: '#f5f9ff', cursor: 'default', outline: 'none' }}
                onClick={() => medInputRef.current?.click()}>
                Вставьте фото (Ctrl+V) или нажмите для выбора файла
              </div>
            )}
            {medPendingFile && (
              <div style={{ background: '#f0f7ff', border: '1px solid #b3d4f7', borderRadius: 8, padding: '8px 10px', marginBottom: 8 }}>
                <div style={{ fontSize: 12, color: '#555', marginBottom: 6 }}>📎 {medPendingFile.name}</div>
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                  <select value={medLabel} onChange={e => setMedLabel(e.target.value)}
                    style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, border: '1px solid #c0d8f0', flex: 1, minWidth: 140 }}>
                    <option value="">— выберите или введите —</option>
                    <option value="ВИЧ">ВИЧ</option>
                    <option value="Желтая лихорадка">Желтая лихорадка</option>
                  </select>
                  <input value={medLabel} onChange={e => setMedLabel(e.target.value)}
                    placeholder="или введите подпись"
                    style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, border: '1px solid #c0d8f0', flex: 1, minWidth: 120 }} />
                  <button onClick={handleMedUploadConfirm} disabled={medUploading}
                    style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: 'none', background: '#378ADD', color: 'white', cursor: 'pointer' }}>
                    {medUploading ? '...' : '✓ Сохранить'}
                  </button>
                  <button onClick={() => { setMedPendingFile(null); setMedLabel('') }}
                    style={{ fontSize: 11, padding: '4px 8px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>
                    Отмена
                  </button>
                </div>
              </div>
            )}
            {medDocs.length === 0 && !medPendingFile && (
              <div style={{ fontSize: 12, color: '#bbb' }}>Документы не прикреплены</div>
            )}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              {medDocs.map((f, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#fafaf8', border: '1px solid #efefec', borderRadius: 7, padding: '5px 10px' }}>
                  <span style={{ fontSize: 11, color: '#888', fontWeight: 500, minWidth: 80 }}>{f.label || '—'}</span>
                  <a href={f.url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#185FA5', textDecoration: 'none', flex: 1 }}>📄 {f.name}</a>
                  {canEdit && onUpdateCandidate && (
                    <button onClick={() => handleMedDelete(i)} style={{ background: 'none', border: 'none', color: '#E24B4A', cursor: 'pointer', fontSize: 13, padding: '0 2px', lineHeight: 1 }}>✕</button>
                  )}
                </div>
              ))}
            </div>
          </div>

          {(c.visa_docs || []).length > 0 && (
            <div className="route-block" style={{ marginBottom: 10 }}>
              <div className="route-label" style={{ margin: 0, marginBottom: 6 }}>🌍 Туристическая виза</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                {(c.visa_docs || []).map((f, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#fafaf8', border: '1px solid #efefec', borderRadius: 7, padding: '5px 10px' }}>
                    <a href={f.url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#185FA5', textDecoration: 'none', flex: 1 }}>📄 {f.name}</a>
                  </div>
                ))}
              </div>
            </div>
          )}

          {(visaIssuedAt || visaReceivedAt || c.visa_received_photo) && (
            <div className="route-block" style={{ marginBottom: 10 }}>
              <div className="route-label">Спецвиза</div>
              {visaIssuedAt && (
                <div style={{ fontSize: 12, color: '#e65100', fontWeight: 600, marginBottom: 4 }}>
                  📬 Виза вышла · {new Date(visaIssuedAt).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Moscow' })}
                </div>
              )}
              {visaReceivedAt && (
                <div style={{ fontSize: 12, color: '#6a1b9a', fontWeight: 600, marginBottom: 6 }}>
                  ✅ Виза получена · {new Date(visaReceivedAt).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Moscow' })}
                </div>
              )}
              {c.visa_received_photo && (
                <div>
                  <a href={c.visa_received_photo} target="_blank" rel="noreferrer">
                    <img src={c.visa_received_photo} alt="Фото визы" style={{ maxWidth: '100%', maxHeight: 220, borderRadius: 8, border: '2px solid #ce93d8', objectFit: 'contain', display: 'block', marginBottom: 6 }} />
                  </a>
                  <label style={{ fontSize: 11, padding: '4px 10px', borderRadius: 7, border: '1px solid #ba68c8', background: '#f3e5f5', color: '#6a1b9a', cursor: 'pointer', fontWeight: 600, display: 'inline-block' }}>
                    🔄 Заменить фото
                    <input type="file" accept="image/*" style={{ display: 'none' }} onChange={async (e) => {
                      const file = e.target.files[0]
                      if (!file) return
                      if (!window.confirm('Заменить фото визы и отправить новое уведомление в бот?')) return
                      try {
                        const url = await uploadPhoto(file, c.id)
                        await sendVisaReceived(c.id, url)
                        alert('✅ Фото заменено, уведомление отправлено.')
                        window.location.reload()
                      } catch(err) { alert('Ошибка: ' + err.message) }
                    }} />
                  </label>
                </div>
              )}
            </div>
          )}

          {c.visas && c.visas.length > 0 && (
            <div className="route-block" style={{ marginBottom: 10 }}>
              <div className="route-label">Визы</div>
              {c.visas.map((visa, i) => (
                <div key={i} style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>🛂 {visa.name || 'Виза ' + (i+1)}</div>
                  {visa.submission_date && <div style={{ fontSize: 11, color: '#888', marginBottom: 2 }}>Дата подачи: {String(visa.submission_date).slice(0,10).split('-').reverse().join('.')}</div>}
                  {visa.application_number && <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>№ заявки: {visa.application_number}</div>}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {(visa.files || []).map((f, fi) => (
                      <a key={fi} href={f.url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#185FA5', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 4 }}>📄 {f.name}</a>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {c.expenses && c.expenses.length > 0 && (() => {
            const visibleExpenses = isAdmin ? c.expenses : c.expenses.filter(e => e.operator_id === currentUserId)
            if (visibleExpenses.length === 0) return null
            return <ExpensesBlock expenses={visibleExpenses} total={visibleExpenses.reduce((sum, e) => sum + (parseFloat(e.amount) || 0), 0)} />
          })()}

          {(candidateTasks.length > 0 || canEdit) && (
            <div className="route-block" style={{ marginBottom: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <div className="route-label" style={{ margin: 0 }}>Задачи</div>
                <button onClick={() => fetchCandidateTasks(c.id).then(setCandidateTasks).catch(() => {})}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, color: '#aaa', padding: '0 2px' }} title="Обновить">↻</button>
              </div>
              {candidateTasks.map(task => {
                const overdue = task.due_date && new Date(task.due_date) < new Date(new Date().toDateString())
                return (
                  <div key={task.id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '5px 0', borderBottom: '0.5px solid #f5f5f3', borderLeft: task.priority === 'urgent' ? '3px solid #E24B4A' : 'none', paddingLeft: task.priority === 'urgent' ? 6 : 0 }}>
                    <button onClick={async () => {
                      const isDone = task.status === 'done'
                      await updateTask(task.id, isDone ? { status: 'open', completed_at: null } : { status: 'done', completed_at: new Date().toISOString() })
                      setCandidateTasks(prev => prev.map(t => t.id === task.id ? { ...t, status: isDone ? 'open' : 'done' } : t))
                    }} style={{ width: 18, height: 18, borderRadius: '50%', border: `2px solid ${task.status === 'done' ? '#639922' : '#ccc'}`, background: task.status === 'done' ? '#639922' : 'white', cursor: 'pointer', flexShrink: 0, marginTop: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }} title={task.status === 'done' ? 'Вернуть' : 'Выполнено'}>
                      {task.status === 'done' && <span style={{ color: 'white', fontSize: 10, fontWeight: 700 }}>✓</span>}
                    </button>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 12, fontWeight: 500, color: task.status === 'done' ? '#aaa' : '#1a2332', textDecoration: task.status === 'done' ? 'line-through' : 'none' }}>{task.title}</div>
                      {task.due_date && task.status !== 'done' && <div style={{ fontSize: 11, color: overdue ? '#E24B4A' : '#aaa' }}>{overdue ? '⚠ ' : ''}до {new Date(task.due_date).toLocaleDateString('ru-RU')}</div>}
                    </div>
                  </div>
                )
              })}
              {canEdit && (
                <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
                  <input value={taskInput} onChange={e => setTaskInput(e.target.value)}
                    onKeyDown={async e => {
                      if (e.key !== 'Enter' || !taskInput.trim()) return
                      setTaskSaving(true)
                      try {
                        const t = await addTask({ title: taskInput.trim(), candidate_id: c.id, candidate_name: c.name })
                        setCandidateTasks(prev => [...prev, t])
                        setTaskInput('')
                      } catch(err) { alert(err.message) }
                      setTaskSaving(false)
                    }}
                    placeholder="Новая задача... (Enter)" style={{ flex: 1, fontSize: 12, padding: '5px 8px', borderRadius: 6, border: '1px solid #e0e0dc', outline: 'none' }} />
                </div>
              )}
            </div>
          )}

          {tickets.length > 0 && (
            <div className="route-block" style={{ marginBottom: 10 }}>
              <div className="route-label">Билеты</div>
              {tickets.map(t => (
                <div key={t.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: '0.5px solid #f5f5f3', gap: 8 }}>
                  <div style={{ fontSize: 12 }}>
                    <div style={{ fontWeight: 500 }}>{t.from_city} → {t.to_city}</div>
                    <div style={{ color: '#888', fontSize: 11 }}>{t.departure_date ? String(t.departure_date).slice(0,10).split('-').reverse().join('.') : ''}</div>
                  </div>
                  {canEdit ? (
                    <select value={t.refund_status || ''} onChange={e => handleStatusChange(t.id, e.target.value)} style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, border: '1px solid #e0e0dc' }}>
                      <option value="">В процессе</option>
                      <option value="Успех">Успех (долетел)</option>
                      <option value="Возврат">Возврат (не долетел)</option>
                    </select>
                  ) : (
                    <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, background: t.refund_status === 'Возврат' ? '#FCEBEB' : t.refund_status === 'Успех' ? '#EAF3DE' : '#FAEEDA', color: t.refund_status === 'Возврат' ? '#E24B4A' : t.refund_status === 'Успех' ? '#27500A' : '#633806' }}>
                      {t.refund_status || 'В процессе'}
                    </span>
                  )}
                </div>
              ))}
            </div>
          )}

          <div className="route-block">
            <div className="route-label">Маршрут</div>
            {route.length === 0 && <div style={{ fontSize: 12, color: '#999' }}>Маршрут не указан</div>}
            {(() => {
              const groups = []
              route.forEach(point => {
                const tid = point.ticket_id
                if (tid) {
                  const existing = groups.find(g => g.ticket_id === tid)
                  if (existing) { existing.points.push(point); return }
                }
                groups.push({ ticket_id: tid || null, points: [point], is_return: point.is_return, transport_type: point.transport_type })
              })
              return groups.map((group, gi) => {
                const isReturn = group.is_return
                const isBus = group.transport_type === 'автобус'
                const icon = isBus ? '🚌' : '✈'
                const allFiles = group.points.flatMap(p => p.files || []).filter((f, i, arr) => arr.findIndex(x => x.url === f.url) === i)
                return (
                  <div key={gi} style={{ marginBottom: 14 }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <div style={{ width: 20, height: 20, borderRadius: '50%', background: '#1a1a1a', color: 'white', fontSize: 10, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 2 }}>{gi + 1}</div>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
                          {isReturn && <span style={{ fontSize: 10, fontWeight: 600, padding: '1px 6px', borderRadius: 10, background: '#E6F1FB', color: '#0C447C' }}>обратный</span>}
                        </div>
                        {group.points.map((point, pi) => (
                          <div key={pi}>
                            {pi > 0 && <div style={{ borderTop: '1px dashed #e0e0dc', margin: '8px 0', borderStyle: 'dashed' }} />}
                            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 2 }}>{icon} {point.from || '—'}</div>
                            <TimeBlock date={point.from_date} time={point.from_time} tz={point.from_tz} />
                            <div style={{ textAlign: 'center', color: '#ccc', fontSize: 16, margin: '6px 0' }}>↓</div>
                            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 2 }}>🛬 {point.to || '—'}</div>
                            <TimeBlock date={point.to_date} time={point.to_time} tz={point.to_tz} />
                          </div>
                        ))}
                        <div style={{ marginTop: 6, display: 'flex', flexWrap: 'wrap', gap: 4, alignItems: 'center' }}>
                          {allFiles.map((f, fi) => (
                            <span key={fi} className="file-chip" style={{ display: 'inline-flex', alignItems: 'center', gap: 2, background: '#f0f4fa', borderRadius: 4, padding: '1px 5px' }}>
                              <a href={f.url} target="_blank" rel="noreferrer" className="file-chip-link" style={{ fontSize: 11, color: '#185FA5', textDecoration: 'none' }}>📎 {f.name}</a>
                              {canEdit && onUpdateCandidate && (
                                <button onClick={async () => {
                                  if (!window.confirm('Удалить этот файл?')) return
                                  const newRoute = (c.route || []).map(p => {
                                    if (!(p.files || []).some(x => x.url === f.url)) return p
                                    return { ...p, files: (p.files || []).filter(x => x.url !== f.url) }
                                  })
                                  await onUpdateCandidate(c.id, { route: newRoute })
                                }} title="Удалить файл" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#e57373', fontSize: 13, padding: '0 2px', lineHeight: 1 }}>✕</button>
                              )}
                            </span>
                          ))}
                          {canEdit && onUpdateCandidate && (
                            <label className="file-add-btn" style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 11, color: '#185FA5', cursor: 'pointer', background: '#f0f4fa', borderRadius: 4, padding: '2px 7px', border: '1px dashed #b0c8e8' }}>
                              + файл
                              <input type="file" style={{ display: 'none' }} onChange={async e => {
                                const file = e.target.files[0]
                                if (!file) return
                                e.target.value = ''
                                try {
                                  const uploaded = await uploadRouteFile(file, c.id, `g${gi}_${Date.now()}`)
                                  const firstPoint = group.points[0]
                                  let patched = false
                                  const newRoute = (c.route || []).map(p => {
                                    if (!patched && p === firstPoint) { patched = true; return { ...p, files: [...(p.files || []), uploaded] } }
                                    return p
                                  })
                                  await onUpdateCandidate(c.id, { route: newRoute })
                                } catch (err) { alert('Ошибка загрузки: ' + err.message) }
                              }} />
                            </label>
                          )}
                        </div>
                      </div>
                    </div>
                    {gi < groups.length - 1 && <div style={{ borderTop: '1px dashed #efefec', margin: '10px 0 0 28px' }} />}
                  </div>
                )
              })
            })()}
          </div>
          </>
          )}
        </div>
        <div className="modal-actions" style={{ flexWrap: 'wrap', gap: 6 }}>
          {canDelete && !isMoscowOperator && !deleteConfirm && <button className="btn btn-danger" onClick={() => setDeleteConfirm(true)}>Удалить</button>}
          {canDelete && !isMoscowOperator && deleteConfirm && (
            <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
              <span style={{ fontSize: 12, color: '#c62828', fontWeight: 600 }}>Удалить "{c.name}"?</span>
              <button onClick={onDelete} style={{ fontSize: 12, padding: '5px 10px', borderRadius: 8, border: 'none', background: '#c62828', color: 'white', cursor: 'pointer', fontWeight: 600 }}>✓ Да</button>
              <button onClick={() => setDeleteConfirm(false)} style={{ fontSize: 12, padding: '5px 8px', borderRadius: 8, border: '1px solid #ccc', background: 'white', cursor: 'pointer', color: '#888' }}>Нет</button>
            </span>
          )}
          {canEdit && (
            <button
              title={fastMark ? `Отмечен ${new Date(fastMark.at).toLocaleDateString('ru-RU')}${fastMark.by ? ' · ' + fastMark.by : ''} — нажмите, чтобы снять` : 'Перенести во вкладку «⚡ ПЕРЕПОДАЧА»'}
              onClick={async () => {
                if (fastMark && !window.confirm(`Снять отметку «Ускоренная переподача» с ${c.name}? Кандидат вернётся в свою колонку.`)) return
                const updates = fastMark
                  ? { fast_resubmit_at: null, fast_resubmit_by: null, fast_resubmit_by_id: null }
                  : { fast_resubmit_at: new Date().toISOString(), fast_resubmit_by: currentUser?.full_name || '', fast_resubmit_by_id: currentUserId || null }
                try {
                  if (onUpdateCandidate) await onUpdateCandidate(c.id, updates)
                  else await updateCandidate(c.id, updates)
                  setFastMark(fastMark ? null : { at: updates.fast_resubmit_at, by: updates.fast_resubmit_by })
                } catch (e) { alert('Ошибка: ' + e.message) }
              }}
              style={{ fontSize: 12, padding: '6px 10px', borderRadius: 8, cursor: 'pointer', fontWeight: 600,
                border: '1px solid #F59E0B', background: fastMark ? '#B45309' : '#FFFBEB', color: fastMark ? 'white' : '#92400E' }}
            >
              {fastMark ? `⚡ Ускоренная переподача · с ${new Date(fastMark.at).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' })}${fastMark.by ? ' · ' + fastMark.by : ''}` : '⚡ Ускоренная переподача'}
            </button>
          )}
          {canEdit && !isMoscowOperator && <button className="btn btn-outline" onClick={onArchive} style={{ borderColor: '#EF9F27', color: '#EF9F27', fontSize: 12, padding: '6px 10px' }}>{c.archived ? '📤 Восстановить' : '📦 В архив'}</button>}
          {onMoveToMain && <button className="btn btn-outline" onClick={onMoveToMain} style={{ borderColor: '#7c5fe6', color: '#7c5fe6', fontSize: 12, padding: '6px 10px', fontWeight: 600 }}>↩ В основную</button>}
          {!isDwan && !isMoscowOperator && specvisaLastSent && !visaIssuedAt && !visaReceivedAt && (
            resubmitStep === 0 ? (
              <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
                <button disabled style={{ fontSize: 12, padding: '6px 10px', borderRadius: 8, border: '1px solid #aaa', background: '#f5f5f5', color: '#999', cursor: 'not-allowed', fontWeight: 600 }}>
                  📤 СВ отправлена
                </button>
                <button onClick={() => { setResubmitEmbassy(''); setResubmitStep(1) }}
                  style={{ fontSize: 11, padding: '4px 8px', borderRadius: 7, border: '1px solid #4a90d9', background: '#e8f0fe', color: '#1a56cc', cursor: 'pointer', fontWeight: 600 }}>
                  🔄 Переподать
                </button>
              </span>
            ) : resubmitStep === 1 ? (
              <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                <span style={{ fontSize: 12, color: '#555', fontWeight: 600 }}>Посольство:</span>
                <input value={resubmitEmbassy} onChange={e => setResubmitEmbassy(e.target.value)} placeholder="Посольство"
                  style={{ padding: '4px 8px', border: '1px solid #ccc', borderRadius: 6, fontSize: 13, minWidth: 130 }} autoFocus />
                <button disabled={resubmitSending || !resubmitEmbassy.trim()} onClick={async () => {
                  if (!c.passport_photos?.length) {
                    alert('У кандидата нет фото паспорта. Загрузите фото перед отправкой спецвизы.')
                    return
                  }
                  setResubmitSending(true)
                  try {
                    const opName = currentUser?.full_name || currentUser?.email || ''
                    await sendSpecvisa(c.id, resubmitEmbassy.trim(), opName)
                    setSpecvisaLastSent({ at: new Date().toISOString(), by: opName })
                    setResubmitStep(0)
                    setResubmitEmbassy('')
                    alert('Переподано!')
                  } catch(e) { alert('Ошибка: ' + e.message) } finally { setResubmitSending(false) }
                }} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 7, background: '#1a56cc', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600 }}>
                  {resubmitSending ? '...' : '📤 Отправить'}
                </button>
                <button onClick={() => setResubmitStep(0)} style={{ fontSize: 12, padding: '4px 8px', borderRadius: 7, background: '#f0f0ec', border: 'none', cursor: 'pointer' }}>Отмена</button>
              </span>
            ) : null
          )}
          {!isDwan && !isMoscowOperator && tourvisaLastSent && !specvisaLastSent && !visaIssuedAt && !visaReceivedAt && (
            <button disabled style={{ fontSize: 12, padding: '6px 10px', borderRadius: 8, border: '1px solid #aaa', background: '#f5f5f5', color: '#999', cursor: 'not-allowed', fontWeight: 600 }}>
              🌍 ТВ отправлена · {tourvisaLastSent.embassy}
            </button>
          )}
          {!isDwan && !isMoscowOperator && !specvisaLastSent && !tourvisaLastSent && !visaIssuedAt && !visaReceivedAt && (
            <>
            {showVisaPanel ? (
              <span style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                {!visaType ? (
                  <>
                    <span style={{ fontSize: 12, color: '#555', fontWeight: 600 }}>Тип визы:</span>
                    <button onClick={() => setVisaType('spec')} style={{ fontSize: 12, padding: '5px 10px', borderRadius: 8, border: '1px solid #4a90d9', background: '#e8f0fe', color: '#1a56cc', cursor: 'pointer', fontWeight: 600 }}>📤 Спецвиза</button>
                    <button onClick={() => setVisaType('tour')} style={{ fontSize: 12, padding: '5px 10px', borderRadius: 8, border: '1px solid #0A7C5C', background: '#e6f4f0', color: '#0A7C5C', cursor: 'pointer', fontWeight: 600 }}>🌍 Турвиза</button>
                    <button className="btn btn-outline" onClick={() => { setShowVisaPanel(false); setVisaType(null); setVisaEmbassy('') }} style={{ fontSize: 12, padding: '5px 10px' }}>Отмена</button>
                  </>
                ) : (
                  <>
                    <span style={{ fontSize: 12, color: '#555', fontWeight: 600 }}>{visaType === 'spec' ? '📤 Спецвиза' : '🌍 Турвиза'} — посольство:</span>
                    <input
                      placeholder="Посольство"
                      value={visaEmbassy}
                      onChange={e => setVisaEmbassy(e.target.value)}
                      style={{ padding: '5px 8px', border: '1px solid #ccc', borderRadius: 6, fontSize: 13, minWidth: 160 }}
                    />
                    <button
                      className="btn btn-primary"
                      disabled={visaSending || !visaEmbassy.trim()}
                      onClick={async () => {
                        if (visaType === 'spec' && !c.passport_photos?.length) {
                          alert('У кандидата нет фото паспорта. Загрузите фото перед отправкой спецвизы.')
                          return
                        }
                        setVisaSending(true)
                        try {
                          const opName = currentUser?.full_name || currentUser?.email || ''
                          if (visaType === 'spec') {
                            await sendSpecvisa(c.id, visaEmbassy.trim(), opName)
                            setSpecvisaLastSent({ at: new Date().toISOString(), by: opName })
                          } else {
                            await sendTourvisa(c.id, visaEmbassy.trim(), opName)
                            setTourvisaLastSent({ at: new Date().toISOString(), embassy: visaEmbassy.trim() })
                          }
                          alert('Отправлено!')
                          setShowVisaPanel(false)
                          setVisaType(null)
                          setVisaEmbassy('')
                        } catch (e) {
                          alert('Ошибка: ' + e.message)
                        } finally {
                          setVisaSending(false)
                        }
                      }}
                      style={{ fontSize: 12, padding: '6px 10px' }}
                    >{visaSending ? '...' : '📤 Отправить'}</button>
                    <button className="btn btn-outline" onClick={() => { setVisaType(null); setVisaEmbassy('') }} style={{ fontSize: 12, padding: '6px 10px' }}>← Назад</button>
                    <button className="btn btn-outline" onClick={() => { setShowVisaPanel(false); setVisaType(null); setVisaEmbassy('') }} style={{ fontSize: 12, padding: '6px 10px' }}>Отмена</button>
                  </>
                )}
              </span>
            ) : (
              <button onClick={() => setShowVisaPanel(true)} style={{ fontSize: 12, padding: '6px 10px', borderRadius: 8, border: '1px solid #4a90d9', background: '#e8f0fe', color: '#1a56cc', cursor: 'pointer', fontWeight: 600 }}>🛂 ВИЗА</button>
            )}
            </>
          )}
          {!isDwan && !isMoscowOperator && !visaIssuedAt && !visaReceivedAt && (
            <>
            {peterVisaAt ? (
              <button
                onClick={async () => {
                  if (!window.confirm(`Снять отметку «Виза подана · ПИТЕР» с кандидата ${c.name}?`)) return
                  const token = localStorage.getItem('auth_token')
                  await fetch(`/api/candidates/${c.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify({ peter_visa_submitted_at: null }) })
                  setPeterVisaAt(null)
                }}
                style={{ fontSize: 12, padding: '6px 10px', borderRadius: 8, border: '1px solid #ef5350', background: '#fdecea', color: '#b71c1c', cursor: 'pointer', fontWeight: 600 }}
              >
                ✈️ Виза подана · ПИТЕР · {new Date(peterVisaAt).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' })}
              </button>
            ) : (
              <button
                onClick={async () => {
                  const now = new Date().toISOString()
                  const token = localStorage.getItem('auth_token')
                  await fetch(`/api/candidates/${c.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify({ peter_visa_submitted_at: now }) })
                  setPeterVisaAt(now)
                }}
                style={{ fontSize: 12, padding: '6px 10px', borderRadius: 8, border: '1px solid #ef5350', background: 'white', color: '#b71c1c', cursor: 'pointer', fontWeight: 600 }}
              >
                ✈️ Питер
              </button>
            )}
            </>
          )}
          {!isDwan && !visaReceivedAt && !visaIssuedAt && !!(specvisaLastSent || tourvisaLastSent || c.bot_visa_date || (c.visas || []).find(v => v.submission_date)) && (
            !visaIssuedConfirm ? (
              <button onClick={() => setVisaIssuedConfirm(true)} style={{ fontSize: 12, padding: '6px 10px', borderRadius: 8, border: '1px solid #1565c0', background: '#e3f2fd', color: '#1565c0', cursor: 'pointer', fontWeight: 600 }}>
                📬 Виза вышла
              </button>
            ) : (
              <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
                <span style={{ fontSize: 12, color: '#1565c0', fontWeight: 600 }}>Подтвердить?</span>
                <button disabled={visaIssuedSending} onClick={async () => {
                  setVisaIssuedSending(true)
                  try {
                    await sendVisaIssued(c.id)
                    setVisaIssuedAt(new Date().toISOString())
                    setVisaIssuedConfirm(false)
                  } catch(e) { alert('Ошибка: ' + e.message) }
                  finally { setVisaIssuedSending(false) }
                }} style={{ fontSize: 12, padding: '5px 10px', borderRadius: 8, border: 'none', background: '#1565c0', color: 'white', cursor: 'pointer', fontWeight: 600 }}>
                  {visaIssuedSending ? '...' : '✓ Да'}
                </button>
                <button onClick={() => setVisaIssuedConfirm(false)} style={{ fontSize: 12, padding: '5px 8px', borderRadius: 8, border: '1px solid #ccc', background: 'white', cursor: 'pointer', color: '#888' }}>Нет</button>
              </span>
            )
          )}
          {!isDwan && visaIssuedAt && !visaReceivedAt && (
            !showVisaReceived ? (
              <button onClick={() => setShowVisaReceived(true)}
                style={{ fontSize: 12, padding: '6px 10px', borderRadius: 8, border: '1px solid #2e7d32', background: '#e8f5e9', color: '#2e7d32', cursor: 'pointer', fontWeight: 600 }}>
                📸 Виза получена
              </button>
            ) : (
              <div style={{ background: '#e8f5e9', border: '1px solid #2e7d32', borderRadius: 10, padding: 10, minWidth: 220 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#2e7d32', marginBottom: 8 }}>📸 Виза получена — загрузить фото</div>
                {!visaPhotoPreview ? (
                  <div>
                    <button onClick={() => setShowVisaPaste(v => !v)}
                      style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: '1px solid #a5d6a7', background: 'white', cursor: 'pointer', color: '#2e7d32', marginBottom: 4 }}>
                      + Выбрать / вставить фото
                    </button>
                    {showVisaPaste && (
                      <div ref={visaPasteRef} onPaste={handleVisaPaste} tabIndex={0}
                        style={{ marginTop: 4, border: '2px dashed #81c784', borderRadius: 8, padding: '14px 12px', textAlign: 'center', fontSize: 13, color: '#555', background: '#f1f8e9', cursor: 'pointer', outline: 'none' }}
                        onClick={() => {
                          const inp = document.createElement('input')
                          inp.type = 'file'; inp.accept = 'image/*'
                          inp.onchange = ev => {
                            const file = ev.target.files[0]
                            if (!file) return
                            setShowVisaPaste(false)
                            setVisaPhotoFile(file)
                            setVisaPhotoPreview(URL.createObjectURL(file))
                          }
                          inp.click()
                        }}>
                        Вставьте фото (Ctrl+V) или нажмите для выбора файла
                      </div>
                    )}
                  </div>
                ) : (
                  <div>
                    <img src={visaPhotoPreview} alt="preview" style={{ width: '100%', maxHeight: 180, objectFit: 'contain', borderRadius: 6, marginBottom: 8, border: '1px solid #c8e6c9' }} />
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button disabled={visaReceivedSending} onClick={async () => {
                        setVisaReceivedSending(true)
                        try {
                          const url = await uploadPhoto(visaPhotoFile, c.id)
                          await sendVisaReceived(c.id, url)
                          setVisaReceivedAt(new Date().toISOString())
                          setShowVisaReceived(false)
                          setVisaPhotoFile(null)
                          setVisaPhotoPreview(null)
                          alert('✅ Виза получена! Уведомление с фото отправлено.')
                        } catch(err) { alert('Ошибка: ' + err.message) }
                        finally { setVisaReceivedSending(false) }
                      }} style={{ fontSize: 12, padding: '6px 12px', borderRadius: 8, border: 'none', background: '#2e7d32', color: 'white', cursor: 'pointer', fontWeight: 600 }}>
                        {visaReceivedSending ? 'Отправка...' : '✅ Подтвердить и отправить'}
                      </button>
                      <button onClick={() => { setVisaPhotoFile(null); setVisaPhotoPreview(null) }}
                        style={{ fontSize: 12, padding: '6px 10px', borderRadius: 8, border: '1px solid #ccc', background: 'white', cursor: 'pointer', color: '#888' }}>
                        Другое фото
                      </button>
                    </div>
                  </div>
                )}
                <button onClick={() => { setShowVisaReceived(false); setVisaPhotoFile(null); setVisaPhotoPreview(null) }}
                  style={{ fontSize: 12, padding: '4px 10px', borderRadius: 8, border: '1px solid #ccc', background: 'white', cursor: 'pointer', color: '#888', marginTop: 6 }}>
                  Отмена
                </button>
              </div>
            )
          )}
          {chertStep === 0 && (
            <button className="btn btn-outline" onClick={() => setChertStep(1)}
              style={{ borderColor: '#e57373', color: '#c0392b', fontSize: 12, padding: '6px 10px', fontWeight: 600 }}>
              {isChert ? '😈 Уже в чертях' : '😈 В черти'}
            </button>
          )}
          {chertStep === 1 && (
            <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
              <span style={{ fontSize: 12, color: '#c0392b', fontWeight: 600 }}>Записать в черти?</span>
              <button onClick={() => setChertStep(2)} style={{ fontSize: 12, padding: '5px 12px', borderRadius: 7, background: '#c0392b', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600 }}>Да</button>
              <button onClick={() => setChertStep(0)} style={{ fontSize: 12, padding: '5px 10px', borderRadius: 7, background: '#f0f0ec', border: 'none', cursor: 'pointer' }}>Нет</button>
            </span>
          )}
          {chertStep === 2 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, width: '100%' }}>
              <textarea value={chertReason} onChange={e => setChertReason(e.target.value)} rows={2} autoFocus
                placeholder="Причина (что натворил)..."
                style={{ width: '100%', padding: '7px 10px', borderRadius: 8, border: '1px solid #f5c6cb', fontSize: 12, resize: 'vertical', boxSizing: 'border-box' }} />
              <div style={{ display: 'flex', gap: 6 }}>
                <button disabled={chertSaving || !chertReason.trim()} onClick={async () => {
                  setChertSaving(true)
                  try {
                    await updateChert(c.id, true, chertReason.trim())
                    setIsChert(true)
                    setChertStep(0)
                    setChertReason('')
                    if (onUpdateCandidate) await onUpdateCandidate(c.id, { archived: true, is_chert: true, chert_reason: chertReason.trim() })
                    onClose()
                  } catch(e) { alert('Ошибка: ' + e.message) } finally { setChertSaving(false) }
                }} style={{ fontSize: 12, padding: '5px 12px', borderRadius: 7, background: '#c0392b', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600 }}>
                  {chertSaving ? '...' : '😈 Подтвердить'}
                </button>
                <button onClick={() => { setChertStep(0); setChertReason('') }} style={{ fontSize: 12, padding: '5px 10px', borderRadius: 7, background: '#f0f0ec', border: 'none', cursor: 'pointer' }}>Отмена</button>
              </div>
            </div>
          )}
          <button className="btn btn-outline" onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  )
}

export default LocationModal